import React, { useState, useEffect, useRef } from "react";
import { usePost } from "seed/api";
import SelectField from "components/util/schema_form/fields/SelectField"
import l from "components/util/l";

const DynamicSelectField = (props) => {

  const userId = sessionStorage.getItem("id");
  const name = props.name;
  const flowId = props.flowId;
  const nodeId = props.nodeId;
  const dynamicDependencies = props.dynamicDependencies ?? [];
  const dynamicOptions = props.dynamicOptions;
  const source = dynamicOptions.source ?? "";
  const sourceValue = dynamicOptions.value ?? "";
  const value = props.value;
  const defaultValue = props.defaultValue;
  const values = props.values;
  const setFieldValue = props.setFieldValue;
  const getOptions = dynamicOptions.get_options ?? (() => []);
  const callParams = dynamicOptions.call_params ?? {};
  const actionId = props.actionId;
  const sectionIdx = props.sectionIdx;
  const hasAllDependencies = dynamicDependencies.filter(depName => depName in values).length == dynamicDependencies.length;
  const [options, setOptions] = useState(null)
  const [depsValues, setDepsValues] = useState(null)
  const isDependencyChange = useRef(false)
  const [callCall, reqCall] = usePost(`/call/${actionId}/${sourceValue}`, {
    onCompleted: (data) => setOptions(data)
  })

  const initOptions = () => {
    if (value === undefined && defaultValue != null)
      setFieldValue(name, defaultValue)
    setOptions(null)
    if (source == "CALL")
      callCall({
        user_id: parseInt(userId),
        flow_id: parseInt(flowId),
        node_id: parseInt(nodeId),
        parent_id: parseInt(props.parentId),
        section_idx: sectionIdx,
        values: props.values,
        call_params: callParams
      })
    else if (source == "callback")
      setOptions(getOptions(sectionIdx, values))
  }

  useEffect(() => {
    if (hasAllDependencies) {
      const newDepsValues = dynamicDependencies.map(depName => values[depName])
      //If there are no change in deps, break
      if (JSON.stringify(depsValues) == JSON.stringify(newDepsValues)) return
      isDependencyChange.current = depsValues != null
      setDepsValues(newDepsValues)
      initOptions()
    }
  }, [values]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // After a dependency change, a value missing from the new options was picked under the previous ones
    if (!isDependencyChange.current || !Array.isArray(options)) return
    isDependencyChange.current = false
    if (props.openText || props.multiple || value == null) return
    if (!options.some(option => option.value == value))
      setFieldValue(name, defaultValue)
  }, [options]); // eslint-disable-line react-hooks/exhaustive-deps

  const onChangeSelect = (value, label) => {
    if (props.onChange)
      props.onChange(value, label)
  }

  const loading = options == null || reqCall.loading;
  const error = reqCall.error;
  const placeholder = !hasAllDependencies ? ""
    : error ? l("Ha ocurrido un error%SC048")
      : loading ? l("Cargando...%SC049") : l(props.placeholder ?? "Selecciona una opción%GA025")

  return (
    <SelectField
      {...props}
      placeholder={placeholder}
      options={Array.isArray(options) && !reqCall.loading ? options : []}
      onChange={onChangeSelect}
    />
  )

}

export default DynamicSelectField;